// extracted by mini-css-extract-plugin
export default {"div":"StreameCard_div__HLKre","img":"StreameCard_img__5obTa","h1":"StreameCard_h1__TfM-j","img1":"StreameCard_img1__Hgo-K"};